import { mutationTypes, actionTypes } from 'BASE/store/types';
import { getLottoGameData } from 'BASE/common/lotteryGameData';
import { storage } from 'BASE/common/util/util.storage';

function state() {
    return {
        initialized: false,
        data: {}
    };
}

const mutations = {
    [mutationTypes.SET_LOTTOGAME_DATA](state, payload) {
        state.initialized = true;
        state.data = payload.data;
    }
};

const actions = {
    async [actionTypes.LOTTOGAME_DATA]({ state, commit }) {
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            let gameDatas = await getLottoGameData();
            commit(mutationTypes.SET_LOTTOGAME_DATA, { data: gameDatas });
            return gameDatas;
        } else {
            return {};
        }
    }
};

export default class store {
    constructor() {
        this.state = state();
        this.actions = actions;
        this.mutations = mutations;
    }
}